interface VoiceTroubleTriggerProps {
  onClick: () => void;
}

/**
 * Subtle, always-available "Having trouble?" affordance shown while the
 * visitor is on a live voice call. Quiet by design — it is a safety net, not
 * a competing CTA — but never hidden behind a menu, since a struggling call
 * is exactly when someone needs it to be easy to find. Text-only: none of the
 * curated brand icons fit "trouble" without inventing a new asset.
 */
export const VoiceTroubleTrigger = ({ onClick }: VoiceTroubleTriggerProps) => (
  <button
    type="button"
    onClick={onClick}
    className="rounded-full bg-white/80 px-3 py-1.5 text-[12px] font-medium text-[#8A97A8] backdrop-blur transition-colors hover:bg-white hover:text-[#475569]"
    style={{ boxShadow: "0 2px 10px rgba(15,23,42,0.08)", border: "1px solid rgba(15,23,42,0.06)" }}
  >
    Having trouble?
  </button>
);

export default VoiceTroubleTrigger;
